$(function() {

    $('.panelToggle').click(function() {
        var curIcon  = $(this).attr('src'),
            head     = $(this).closest('.panelHeading'),
            radius   = head.css('border-top-left-radius'),
            isHiding = (curIcon.indexOf('icon_hide') > -1),
            nextIcon;


        if (isHiding) {
            nextIcon = curIcon.replace('icon_hide', 'icon_show');
        } else {
            nextIcon = curIcon.replace('icon_show', 'icon_hide');
            head.removeClass('folded');
        }

        $(this).attr('src', nextIcon);

        $(this).closest('.panelHeading').next('.panelContent').slideToggle(function() {

            if (isHiding) {
                head.addClass('folded');
            }
        });
    });
});
